import { FC, lazy } from 'react';
import { useParams } from 'react-router-dom';
import { PageSpinner } from 'src/components/spinner-container';
import { useTitle } from 'src/hooks/use-title';
import { useBooking } from 'src/pages/reporting/direct-fcfs/bookings/use-booking';
import { useOrganisationServicePublic } from 'src/pages/settings/organisation/use-organisation-service-public';

const Page = lazy(() => import('./page'));

export const ReportingBooking: FC = () => {
  const { bookingId } = useParams<{ bookingId: string }>();
  useTitle(`Direct FCFS Booking`);
  const booking = useBooking({ bookingId });
  const organisationServiceLinks = useOrganisationServicePublic();

  if (!booking.response || !organisationServiceLinks.response)
    return <PageSpinner />;

  return (
    <Page
      bookingRequest={booking}
      organisationService={organisationServiceLinks.response?.data}
    />
  );
};
